module.exports = __webpack_public_path__ + "img/20210118_162053.d8dda1ca.jpg";